"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
class MfaSecret extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'mfaSecret';
        this._secretUrl = initParams.secret_url;
    }
    set secretUrl(value) {
        console.error('Do not set objects this way');
    }
    get secretUrl() {
        return this._secretUrl;
    }
}
exports.default = MfaSecret;
//# sourceMappingURL=mfaSecret.js.map